export const trimmedString = (str = '') => {
  return str.trim()
}
